import { render, staticRenderFns } from "./ConsentAgreement.vue?vue&type=template&id=1956ee7e"
import script from "./ConsentAgreement.vue?vue&type=script&lang=ts"
export * from "./ConsentAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports